import { Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component'; // Adjust the path as needed
import { homepageRoutes } from './homepage/homepage.routes';
import { membershipRoutes } from './membership/membership.routes';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: LandingPageComponent,
  // },
  {
    path: 'vote',
    loadChildren: () => import('./vote/vote.routes').then((c) => c.voteRoutes),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./register/register.component').then((c) => c.RegisterComponent),
  },
  {
    path: 'liff',
    loadComponent: () =>
      import('./liff/liff.component').then((c) => c.LiffComponent),
  },
  {
    path: 'index',
    loadComponent: () =>
      import('./homepage/index.component').then((c) => c.IndexComponent), 
    children: homepageRoutes
  },
  {
    path: 'membership',
    loadComponent: () =>
      import('./membership/index.component').then((c) => c.IndexComponent),
    children: membershipRoutes,
  },
  {
    path: '**',
    redirectTo: 'index',
  },
];
